export const camelToSnake = (data: Record<string, unknown>) => {
  if (!isIterableObject(data)) {
    throw new Error("keyConverter::camelToSnake data is not iterable");
  }

  const target = Array.isArray(data) ? [] : {};

  Object.keys(data).forEach((key) => {
    Object.assign(target, {
      [convertCamelToSnake(key)]: isIterableObject(data[key])
        ? camelToSnake(data[key] as Record<string, unknown>)
        : data[key],
    });
  });

  return target;
};

export const convertCamelToSnake = (key: string) => {
  /**
   * Regex should not camel to snake if:
   * * between a figure (*12 should be *_12, not _1_2)
   * * key starts with capital or figure (snake_case, not _snake_case)
   */
  return key
    .replace(/(?:^|\.?)([A-Z]|\d+)/g, (_, value) => `_${value.toLowerCase()}`)
    .replace(/^_/, "");
};

export const snakeToCamel = (data: Record<string, unknown>) => {
  if (!isIterableObject(data)) {
    throw new Error("keyConverter::snakeToCamel data is not iterable");
  }

  const target = Array.isArray(data) ? [] : {};

  Object.keys(data).forEach((key) => {
    Object.assign(target, {
      [convertSnakeToCamel(key)]: isIterableObject(data[key])
        ? snakeToCamel(data[key] as Record<string, unknown>)
        : data[key],
    });
  });

  return target;
};

export const convertSnakeToCamel = (key: string) => {
  return key.replace(/_\w/g, (value) => value[1].toUpperCase());
};

const isIterableObject = (target: any) => {
  return (
    typeof target === "object" &&
    target !== null &&
    !(target instanceof Blob) &&
    !(target instanceof Date)
  );
};
